module.exports = __webpack_public_path__ + "img/resources.e9796499.svg";